import {useRef} from 'react'
import {useSetState} from "ahooks";
import {message, Switch, Tooltip} from "antd";
import {SActionBtn, SDrawerOrModal, SFuncModalFormRef, SLowcodeList, SMessage, STableActions,} from 'shj-components'
import {businessDictDelete, businessDictUpdateState, getBusinessDictList} from "@/services/product.ts";

import {config} from './config'
import AddOrEditConfigure from "./addOrEdit";

export default function BusinessConfiguration() {
  const listRef = useRef<any>()
  const editRef = useRef<SFuncModalFormRef>({onFinish: undefined});

  const [state, setState] = useSetState(
    {
      exportLoading: false,
      visible: false,
      record: {},
      dataSource: [],
      btnLoading: false,
    })

  const fetchList = ({query}) => {
    return new Promise((resolve, reject) => {
      getBusinessDictList({
        // params: {pageId: current, pageSize},
        data: query,
      }).then(res => {
        resolve({records: res})
        setState({dataSource: res as any})
      }).catch(reject)
    })
  }

  const onAddOrEdit = (record = {}) => {
    setState({visible: true, record: {...record}})
  }

  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return businessDictDelete(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onChangeStatus = (enabled: boolean, id) => {
    SMessage.confirm({
      title: '修改状态',
      content: `是否确认${enabled ? '启用' : '禁用'}该数据`,
      onOk: () => {
        return businessDictUpdateState({idList: [id], enabled}).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const onSubmit = () => {
    editRef.current.onFinish?.()
  };

  const onCancel = () => {
    setState({visible: false, record: {}, btnLoading: false})
  }

  const onSubmitOk = () => {
    listRef.current?.reload();
    onCancel()
  }

  const extensions = {
    request: {fetchList},
    events: {onAdd: () => onAddOrEdit()},
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return <Switch disabled={v && record.object?.initFlag} checked={v}
                       checkedChildren="启用" unCheckedChildren="禁用"
                       onClick={(checked) => onChangeStatus(checked, record.id)}/>
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onAddOrEdit(record.object)}>编辑</SActionBtn>
            {!record.object?.initFlag && <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>}
          </STableActions>
        )
      },
      ellipsisRender(v: string) {
        return <Tooltip title={v}>
          <div style={{width: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>{v}</div>
        </Tooltip>
      }
    },
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal width={500}
                      onCancel={onCancel}
                      onOk={onSubmit}
                      loading={state.btnLoading}
                      open={state.visible}
                      title={(state.record.id ? '编辑' : '新增') + '配置'}
      >
        <AddOrEditConfigure
          tree={state.dataSource}
          editRef={editRef.current}
          fn={onSubmitOk}
          setLoading={(btnLoading: boolean) => setState({btnLoading})}
          record={state.record}/>
      </SDrawerOrModal>
    </div>
  )
}
